// src/services/personEntryService.ts

import { EntryModel } from "../models";
import { ENTRIES_PER_PAGE , API_BASE_URL } from "../constants";
import apiClient from "./apiClient";
import { mapRawEntry as mapEntry } from "./entryMapper";


export interface PersonEntryResponse {
  entries: EntryModel[];
  currentPage: number;
  totalPages: number;
  totalItems: number;
}


/**
 * Fetch paginated entries for a person.
 */
export const fetchEntriesByPersonId = async (
  personId: number,
  page: number = 1,
  pageSize: number = ENTRIES_PER_PAGE,
  showRookieEntries: boolean = true,
  sort: string = "newest",
  filterToday: boolean = false,
  rookieOnly: boolean = false,
  keyword: string = ""
): Promise<PersonEntryResponse> => {
  const params = new URLSearchParams({
    page:              String(page - 1),
    size:              String(pageSize),
    showRookieEntries: String(showRookieEntries),
    sort,
    filterToday:       String(filterToday),
    rookieOnly:        String(rookieOnly),
  });

  // Keyword is optional and omitted when empty
  if (keyword && keyword.trim()) {
    params.append("keyword", keyword.trim());
  }

  const token = localStorage.getItem("token");
  const headers: HeadersInit = { "Content-Type": "application/json" };
  if (token) headers["Authorization"] = `Bearer ${token}`;

  const res = await fetch(`${API_BASE_URL}/api/entries/personId/${personId}?${params}`, { headers });
  if (!res.ok) throw new Error("Kişi entryleri yüklenemedi.");

  const json = await res.json();
  const entries: EntryModel[] = (json.content ?? []).map(mapEntry);
  const totalPages = json.totalPages ?? 1;
  const totalItems = json.totalItems ?? json.totalElements ?? entries.length;

  return { entries, currentPage: page, totalPages, totalItems };
};

/**
 * Post a new entry for a person.
 */
export const postPersonEntry = async (
  content: string,
  personId: number
): Promise<EntryModel> => {
  const raw = await apiClient.post<any>("/api/entries", { content, personId });
  return mapEntry(raw);
};